module.exports = __webpack_public_path__ + "static/img/solution6.ff54b2e.png";


//////////////////
// WEBPACK FOOTER
// ./static/moblieHome/solution6.png
// module id = vNUj
// module chunks = 1